import { render, staticRenderFns } from "./about-product.vue?vue&type=template&id=95e12182"
import script from "./about-product.vue?vue&type=script&lang=js"
export * from "./about-product.vue?vue&type=script&lang=js"
import style0 from "./about-product.vue?vue&type=style&index=0&id=95e12182&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports